import { Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import { UtilsModule } from '../../../../utils/utils.module';
@Component({
  selector: 'app-common-date',
  templateUrl: './common-date.component.html',
  styleUrls: ['../parts.css']
})
export class CommonDateComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 条件列
  columnConditionDisplayText = '日期'; // 条件列默认文字
  columnConditionSelectList: Array<any> = []; // 条件列下拉列
  columnConditionValue = null; // 条件列选中值
  columnConditionPopVisible = false; // 条件列POP显示
  columnConditionData: any = {}; // 条件列入参组装
  // 条件 WHEN
  whenComponentDisplayText = '何时'; // When组件默认文字
  whenConditionPopVisible = false; // When组件POP显示
  whenComponentData: any; // when组件接收存放数据
  // 分组
  groupConditionDisplayText = '分组'; // 条件二默认文字
  groupConditionId = null; // 存放条件二选中ID
  groupConditionPopVisible = false; // 分组POP
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID
  automation: any = {
    'boardId': '',
    'groupId': '',
    'categoryId': '',
    relationId: '',
    'dateTrigger': {},
    'conditions': [],
    'taskMapping': {}
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule
  ) { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    // 初始化下拉项
    switch (this.categorieId) {
      case '1':
        this.columnConditionSelectList = [];
        this.boardColumnData.forEach((item, index) => {
          if (item.type === 'date') {
            const obj = {
              'id': item.id,
              'title': item.title
            };
            this.columnConditionSelectList.push(obj);
          }
        });
        break;
      case '2':
        break;
      case '3':
        this.columnConditionSelectList = [
          {'id': 'contractEndDate', 'title': '到期日'},
          {'id': 'dividendDate', 'title': '分红日'},
          {'id': 'distributionDate', 'title': '收益分配日'}
        ];
        break;
    }
    // 处理返填数据
    if (JSON.stringify(this.instanceData) !== '{}') {
      this.backFillData = this.instanceData.config.taskMapping;
      this.columnConditionValue = this.instanceData.config.conditions[0].value;
      this.columnConditionSelectList.forEach((item, index) => {
        if (item.id === this.columnConditionValue) {
          this.columnConditionDisplayText = item.title;
        }
      });
      this.boardGroupData.forEach((item, index) => {
        if (item.id === this.instanceData.config.groupId) {
          this.groupConditionDisplayText = item.title;
        }
      });
      this.groupConditionId = this.instanceData.config.groupId;
      this.whenComponentData = this.instanceData.config.dateTrigger;
      this.whenComponentDisplayText = this.whenComponentData.description;
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.packageData(this.automation);
    }
  }
  // 条件列 - 选择回调
  columnConditionSelectChange(item) {
    this.columnConditionValue = item.id;
    this.columnConditionDisplayText = item.title;
    this.columnConditionPopVisible = false;
    // 组装入参数据
    this.automation.conditions = [];
    this.columnConditionData = {
      'field': 'dueDate',
      'operator': 'is',
      'value': this.columnConditionValue
    };
    this.automation.conditions.push(this.columnConditionData);
    this.packageData(this.automation);
  }
  // 条件WHEN组件 - 返回数据
  getWhenComponentData(event) {
    this.whenComponentData = event;
    this.whenConditionPopVisible = false;
    this.whenComponentDisplayText = this.whenComponentData.dateTrigger.description;
    this.automation.dateTrigger = this.whenComponentData.dateTrigger;
    this.packageData(this.automation);
  }
  // 条件分组 - 选中回调
  groupConditionChange(item) {
    this.groupConditionPopVisible = false;
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.packageData(this.automation);
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseIntegration.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取组装任务创建数据
  getTaskIntegrationData(event) {
    this.taskIntegrationData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping.mappingConfig = obj;
    });
    this.packageData(this.automation);
  }
  // 组件提交数据
  packageData(data) {
    const instanceDescription = '当' + this.columnConditionDisplayText + '至' + this.whenComponentDisplayText + '，在' + this.groupConditionDisplayText + '中，创建任务';
    data.instanceDescription = instanceDescription;
    this.nfDataChange.emit(data);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return this.columnConditionValue &&
      JSON.stringify(this.automation.dateTrigger) !== '{}' &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) != '{}';
  }
}
